import { Box, CircularProgress, Container } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

class RestablecerContrasenia extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            errores: null,
            notificaciones: null,
            cambio: {
                usuario: '',
                usuarioConfirmado: '',
            },
            usuarioIguales: false,
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioCambio = this.manejarEnvioCambio.bind(this);
    }

    async componentDidMount(){

    }

    render(){
        return (
            <>
                <Container>
                    <h3>Restrablecer Contraseña</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <div className='mt-5'>
                        <hr />
                        <div className='row justify-content-center'>
                            <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                <form onSubmit={this.manejarEnvioDatos}>
                                    <input type="text" className='form-control mb-2' placeholder='INGRESE EL USUARIO' id='usuario' onChange={this.controlarCambios} value={this.state.cambio.usuario}/>
                                    <input type="text" className='form-control mb-2' placeholder='CONFIRMAR USUARIO' id='usuarioConfirmado' onChange={this.controlarCambios} value={this.state.cambio.usuarioConfirmado}/>
                                    {this.state.usuarioIguales ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCambio}>Confirmar</button> : null}
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </>
        )
    }
    controlarCambios(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.cambio;
            registroActualizado[clave] = valor;
            return{
                cambio: registroActualizado,
            };
        })
        if((valor !== '') && (this.state.cambio.usuario === valor)){
            this.setState({
                usuarioIguales: true,
            });
        }else if((valor !== '') && (this.state.cambio.usuarioConfirmado === valor)){
            this.setState({
                usuarioIguales: true,
            });
        }else{
            this.setState({
                usuarioIguales: false,
            });
        }
    }

    async manejarEnvioCambio(e){
        e.preventDefault();
        if((this.state.cambio.usuario === '')){
            this.setState({
                errores: 'Debe ingresar un usuario',
            })
        }else if((this.state.cambio.usuarioConfirmado === '')){
            this.setState({
                errores: 'Debe confirmar el usuario',
            })
        }else if((this.state.cambio.usuario !== this.state.cambio.usuarioConfirmado)){
            this.setState({
                errores: 'Los usuarios deben ser iguales',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.cambio, sessionStorage.numeroFuncionario]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/restrablecer_password.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'La contraseña fue actualizada correctamente',
                    cambio: {
                        usuario: '',
                        usuarioConfirmado: '',
                    },
                    passwordIguales: false,
                })
            }
        }
    }
}

export default RestablecerContrasenia